// src/woodpecker/LichessOAuthCallback.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWoodpeckerAuth } from './Woodpecker';

const REACT_APP_LICHESS_CLIENT_ID = 'woodpecker_lichess_client_25'

export default function LichessOAuthCallback() {
  const { handleAuthAndUserData } = useWoodpeckerAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const code_verifier = localStorage.getItem('pkce_verifier');

    if (!code || !code_verifier) {
      console.error('OAuth code or verifier missing');
      return;
    }
    const tokenParams = new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: REACT_APP_LICHESS_CLIENT_ID,
      code,
      code_verifier,
      redirect_uri: `${window.location.origin}/woodpecker/oauth/callback`,
    });

    fetch('https://oauth.lichess.org/api/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json'
      },
      body: tokenParams
    })
    .then(resp => resp.json())
    .then(async data => {
      if (data.access_token) {
        await handleAuthAndUserData(data.access_token, 'lichess');
        const returnTo = sessionStorage.getItem('lichess_return_to') || '/woodpecker';
        sessionStorage.removeItem('lichess_return_to');
        navigate(/^\/openings(?:\/|\?|$)/.test(returnTo) ? returnTo : '/woodpecker');
      } else {
        console.error('Failed to obtain access token:', data);
      }
    })
    .catch(console.error);
  }, [navigate]);

  return <p>Completing login...</p>;
}
